import axios from 'axios';

type Props = {
    eventUrl: string;
    rotaryCd: string;
}

/**
 * イベントの詳細情報を取得するAPI
 */
export async function getEventDetailInfo({eventUrl, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/me/event`, {
        params: {
            rotaryCd: rotaryCd,
            url: eventUrl
        },
        paramsSerializer:{
            indexes: null
        }
    })
    return JSON.parse(JSON.stringify(response.data[0]))
}